import produce from "immer";

const INITIAL_STATE = {
    retailer: {},
};

export default function auth(state = INITIAL_STATE, action) {
    return produce(state, draft => {
        switch (action.type) {
            case "@retailers/SETRETAILER":
                draft.retailer = action.payload
                break;
            default:
        }
    });
}
